import axios from "axios";
import axiosClient from "../utils/axios";
import { baseEndpoint } from "./baseEndpoint";

const CSRF_META_NAME = "csrf-token";

const readCsrfTokenFromDom = () =>
  document.querySelector(`meta[name="${CSRF_META_NAME}"]`)?.content || "";

const writeCsrfTokenToDom = (token) => {
  let meta = document.querySelector(`meta[name="${CSRF_META_NAME}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = CSRF_META_NAME;
    document.head.appendChild(meta);
  }
  meta.content = token;
};

const fetchCsrfToken = async () => {
  const { data } = await axios.get(`${baseEndpoint}/csrf_token`, {
    withCredentials: true,
  });
  writeCsrfTokenToDom(data.token);
  return data.token;
};

const login = async () => {
  const token = readCsrfTokenFromDom() || (await fetchCsrfToken());

  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${baseEndpoint}/users/auth/auth0`;

  const csrfField = document.createElement("input");
  csrfField.type = "hidden";
  csrfField.name = "authenticity_token";
  csrfField.value = token;
  form.appendChild(csrfField);

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

const logout = async (params) => {
  const data = await axiosClient.delete(`${baseEndpoint}/logout`, {
    params,
  });

  return data;
};

const signUp = async (params) => {
  const data = await axiosClient.post(`${baseEndpoint}/signup`, params);

  return data;
};

const changePassword = async () => {
  const data = await axiosClient.patch(`${baseEndpoint}/change_password`);

  return data;
};

export { login, logout, signUp, changePassword, fetchCsrfToken };
